"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthFailureEnum = exports.ProvisioningMethodsEnum = exports.AuthMethodsEnum = void 0;
var AuthMethodsEnum;
(function (AuthMethodsEnum) {
    AuthMethodsEnum["CREDENTIALS"] = "CREDENTIALS";
    AuthMethodsEnum["GOOGLE_OIDC"] = "GOOGLE_OIDC";
    AuthMethodsEnum["OBO_TOKEN"] = "OBO_TOKEN";
    AuthMethodsEnum["OIDC"] = "OIDC";
    AuthMethodsEnum["SAML"] = "SAML";
})(AuthMethodsEnum = exports.AuthMethodsEnum || (exports.AuthMethodsEnum = {}));
var ProvisioningMethodsEnum;
(function (ProvisioningMethodsEnum) {
    ProvisioningMethodsEnum["API"] = "API";
    ProvisioningMethodsEnum["JIT"] = "JIT";
    ProvisioningMethodsEnum["SCIM"] = "SCIM";
})(ProvisioningMethodsEnum = exports.ProvisioningMethodsEnum || (exports.ProvisioningMethodsEnum = {}));
var AuthFailureEnum;
(function (AuthFailureEnum) {
    AuthFailureEnum["BAD_REQUEST"] = "BAD_REQUEST";
    AuthFailureEnum["EXPIRED_TOKEN"] = "EXPIRED_TOKEN";
    AuthFailureEnum["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    AuthFailureEnum["INVALID_TOKEN"] = "INVALID_TOKEN";
    AuthFailureEnum["TOKEN_NOT_FOUND"] = "TOKEN_NOT_FOUND";
    AuthFailureEnum["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    AuthFailureEnum["UNAUTHORIZED_LOGIN"] = "UNAUTHORIZED_LOGIN";
    AuthFailureEnum["UNKNOWN_USER"] = "UNKNOWN_USER";
    AuthFailureEnum["UNVERIFIED_USER"] = "UNVERIFIED_USER";
})(AuthFailureEnum = exports.AuthFailureEnum || (exports.AuthFailureEnum = {}));
